// generated from 9_472 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const totalNumberOfPurchasesFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("total_number_of_purchases_filter"),
  comparison_key: z.enum([
    "1", // 5_442 (57.45%)
    "3", // 3_282 (34.65%)
    "5", // 748 (7.90%)
  ]),
  display_name: z.string(),
  // undefined: 3_360 (35.47%), defined 6_112 (64.53%)
  // avg: 0.67, min: 0, max: 200
  raw_value: z.int().min(0).optional(),
  // avg: 0.76, min: 0, max: 200
  value: z.int().min(0),
  varies_by_app_group: z.literal(false),
});
